import { useNavigate } from 'react-router-dom';
import { Card, Stack, Typography } from '@mui/material';
import { TopNextButton } from 'components';
import { SpeechDiagonal } from 'pages/Top/style';
import { baseColors } from 'utils/constants';
import SmallStarIcon from 'components/icons/SmallStar';

type Props = {
  mainBodyImage: string;
  air1Image: string;
  price: number;
  title: string;
  subText: string;
  subText2: string;
  rate: number;
  url?: string;
  plan?: string;
};

const PlanCard = (props: Props) => {
  const { mainBodyImage, air1Image, price, title, subText, subText2, rate, url, plan } = props;
  const navigate = useNavigate();
  const handleNext = (): void => {
    if (url) {
      if (url.startsWith('http')) {
        window.location.href = url;
      } else {
        navigate(url);
      }
    } else {
      const path = plan ? `/rental/ec?plan=${plan}` : `/rental/ec`;
      navigate(path);
    }
  };

  return (
    <Card
      sx={{
        width: '300px',
        borderRadius: '10px',
        textAlign: 'center',
        paddingBottom: '20px'
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: baseColors.white,
          fontSize: '18px',
          backgroundColor: baseColors.green,
          borderRadius: '10px 10px 0 0',
          padding: '10px 0',
          textAlign: 'center',
          position: 'relative'
        }}
      >
        <div
          style={{
            display: 'inline-block',
            position: 'absolute',
            top: '0.75rem',
            left: '0.5rem'
          }}
        >
          {[...Array(rate)].map((_, i) => (
            <SmallStarIcon key={i} />
          ))}
        </div>
        {title}
      </Typography>
      <Stack
        direction="row"
        spacing={0}
        sx={{
          padding: '20px 20px 0 20px',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <img src={mainBodyImage} alt="main_body" style={{ paddingBottom: '10px' }} />
          <br />
          <img src={air1Image} alt="air-1" />
        </div>
        <div style={{ textAlign: 'center' }}>
          <Typography
            variant="body1"
            sx={{
              textDecoration: 'underline',
              textDecorationColor: baseColors.red,
              textDecorationThickness: '2px',
              textUnderlineOffset: '4px'
            }}
          >
            {subText}
            <br />
            <span style={{ fontSize: '24px' }}>{subText2}</span>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              padding: '10px 0',
              display: 'flex',
              justifyContent: 'center',
              color: baseColors.red,
              fontWeight: 'bold'
            }}
          >
            <span style={{ fontSize: '46px' }}>{price}</span>
            <span>
              <span style={{ fontSize: '12px' }}>(税込)</span>
              <br />
              <span style={{ fontSize: '20px' }}>円/日</span>
            </span>
          </Typography>
        </div>
      </Stack>
      <Typography
        component="div"
        variant="body1"
        sx={{
          textAlign: 'center',
          fontSize: '12px',
          color: baseColors.blackGray
        }}
      >
        <SpeechDiagonal>15日以上、30日以上でさらにお得！</SpeechDiagonal>
      </Typography>
      <TopNextButton onClick={handleNext} />
    </Card>
  );
};
export default PlanCard;
